exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit-address {\n  padding: 1.08rem 0.53rem;\n}\n.edit-address > .title {\n  font-size: 0.51rem;\n  font-weight: bold;\n  color: #323235;\n  line-height: 1;\n  padding-bottom: 1.07rem;\n}\n", ""]);

// exports
